import React from "react";
import { renderProgressIcon } from "utils/helpers";
import IconCompleted from "assets/Icon-Completed.svg";
import "styles/HomeCategory.scss";

// TODO: refactor
const HomeCategory = ({
  displayName,
  description,
  active,
  complete,
  iconSource,
  iconDimensions,
}) => {
  return (
    <>
      <div className="flex">
        <div className="home-icon-container">
          {renderProgressIcon(
            displayName,
            active,
            complete,
            iconSource,
            iconDimensions
          )}
        </div>
        <div className="right-padding">
          <div className={"home-category-title"}>
            {displayName}
            {complete && (
              <img
                className="completed-checkbox margin-left"
                src={IconCompleted}
                alt="deselect field"
                width="18px"
              />
            )}
          </div>
          <div className="home-description">{description}</div>
        </div>
      </div>
      {complete && <div className="edit">Edit</div>}
    </>
  );
};

export default HomeCategory;
